import React, { useState } from "react";
import Input from "components/input/Input";

export default function PasswordInput({
  placeholder,
  ref,
  onChange,
  error,
  ...rest
}) {
  const [password, setPassword] = useState("");
  const [inputError, setInputError] = useState(null);

  function checkPassword() {
    if (password?.length === 0) setInputError("A Senha parece ser inválida.");
  }

  return (
    <Input
      //ref={passwordRef}
      type="password"
      placeholder={placeholder}
      value={password}
      error={inputError || error}
      onBlur={checkPassword}
      onChange={(event) => {
        const { value } = { ...event.target };
        setPassword(value);
        setInputError(null);
        onChange && onChange(value);
      }}
      {...rest}
    />
  );
}

PasswordInput.defaultProps = {
  placeholder: "Senha",
  ref: null,
  error: null,
  onChange: () => null,
};
